import script from "./PersonHighlights.vue?vue&type=script&lang=ts&setup=true"
export * from "./PersonHighlights.vue?vue&type=script&lang=ts&setup=true"

import "./PersonHighlights.vue?vue&type=style&index=0&id=63dc40c1&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63dc40c1"]])

export default __exports__